import { type ForwardedRef, forwardRef } from 'react';
import { useFormState } from 'react-hook-form';

import { Button, type ButtonProps } from '../../../atoms';

export type SubmitButtonProps = Omit<ButtonProps, 'onClick' | 'type'>;

/**
 * Wraps the Button component and sets disabled and isLoading as appropriate during
 * form submission and verification failure
 */
const SubmitButtonComponent = (props: SubmitButtonProps, ref: ForwardedRef<HTMLButtonElement> | null) => {
	const { isLoading: formIsLoading, isSubmitting, isValid, isValidating } = useFormState();
	const isLoading = props.isLoading || formIsLoading || isSubmitting || isValidating;
	const disabled = props.disabled || isLoading || !isValid;

	const allowClickingToSeeValidationError = props.forceClick || (!isLoading && disabled && !isValid);

	return (
		<Button
			{...props}
			disabled={disabled}
			forceClick={allowClickingToSeeValidationError}
			isLoading={isLoading}
			ref={ref}
			type="submit"
		/>
	);
};

export const SubmitButton = forwardRef(SubmitButtonComponent);
